<form [formGroup]="metaDataForm" [class.dry-run]="!perfLabValue.parallelFlow">
    <div class="mt-4 mb-4">
        <h5>Flow type</h5>
        <!-- checkedLabel="Dry" uncheckedLabel="Formal" reverse -->
        <ui-switch [disabled]="perfLabValue?.testCase?.loadTestType === 'WEB'" checkedLabel="Formal run"
            uncheckedLabel="Dry run" defaultBgColor="#c1bf40" color="transparent" checkedTextColor="white"
            (change)="changeFlowType($event)" [(ngModel)]="perfLabValue.parallelFlow"
            [checked]="perfLabValue.parallelFlow" [ngModelOptions]="{standalone: true}"></ui-switch>
        <div>
            <small class="text-info"
                *ngIf="!perfLabValue.parallelFlow && perfLabValue?.testCase?.loadTestType !== 'WEB'">
                <!-- Note : Duration should be less than 10 min & Concurrent Users must be less than 15. Location restricted only to Oregon. -->
                Note : Dry Run is recommended when users are less than 15 and duration is less than or equal to 10
                min.<br /> Location is also restricted to Oregon. For other cases select Formal Run
            </small>
            <small class="text-info"
                *ngIf="!perfLabValue.parallelFlow && perfLabValue?.testCase?.loadTestType === 'WEB'">
                Note : Duration and concurrent users can take any value. Location restricted only to Oregon.
            </small>
            <small class="text-info" *ngIf="perfLabValue.parallelFlow">
                Note : Duration should be more than 10 min or Concurrent Users must be more than 14.
                <!-- Note : For Formal Run duration should be more than 10 min and Concurrent users should be more than 15. -->
            </small>
        </div>

    </div>
    <div class="row">
        <div class="col-9">
            <div class="perf-box">
                <div class="perf-head">Duration</div>
                <div class="perf-body">
                    <div class="radio">
                        <label>
                            <input type="radio" name="durationType" id="nextAvailable" value="nextAvailable"
                                formControlName="durationType" /> Run the test {{perfLabValue.parallelFlow ? 'now' : 'in
                            the next available slot'}}
                        </label>
                    </div>
                    <hr />
                    <div class="radio">
                        <label><input type="radio" name="durationType" id="custom" value="custom"
                                formControlName="durationType" /> Schedule the test in future slot</label>
                    </div>
                    <div class="row" *ngIf="durationTypeValue === 'custom'">
                        <!-- Calender Section -->
                        <div class="col date-sec">
                            <div class="row form-group">
                                <div class="col-3">Start Date <span class="error-msg">*</span></div>
                                <div class="col-8">
                                    <input class="form-control form-control-sm" type="text" placeholder="dd-month-yyyy"
                                        name="d1" formControlName="autoGoveranceStartDate" (click)="d1.toggle()"
                                        ngbDatepicker #d1="ngbDatepicker" [required]="durationTypeValue === 'custom'"
                                        (dateSelect)="setEndDate($event)" placement="right" [minDate]="startMinDate"
                                        [footerTemplate]="footerTemplated1">
                                </div>
                                <ng-template #footerTemplated1>
                                    <hr class="my-0">
                                    <button class="btn btn-primary btn-sm m-2 float-left today-btn"
                                        (click)="setToday('autoGoveranceStartDate'); d1.close()">Today</button>
                                    <button class="btn btn-secondary btn-sm m-2 float-right"
                                        (click)="resetDate('autoGoveranceStartDate'); d1.close()">Clear</button>
                                </ng-template>
                            </div>
                            <div class="row form-group" [hidden]="perfLabValue.parallelFlow">
                                <div class="col-3">End Date <span class="error-msg">*</span></div>
                                <div class="col-8">
                                    <input class="form-control form-control-sm" type="text" placeholder="dd-month-yyyy"
                                        name="d2" formControlName="autoGoveranceEndDate" (click)="d2.toggle()"
                                        ngbDatepicker #d2="ngbDatepicker" [required]="durationTypeValue === 'custom'"
                                        (dateSelect)="selectEndDate($event)" placement="right" [minDate]="endMinDate"
                                        [footerTemplate]="footerTemplated2">
                                </div>
                                <div class="col-12 text-right mt-3">
                                    <button style="font-size: small;" (click)="viewSlots()" class="btn btn-warning"
                                        *ngIf="(autoGoveranceEndDateValue && autoGoveranceEndDateValue !== undefined) && (perfLabValue.parallelFlow===false)">View
                                        blocked slots</button>
                                </div>
                                <ng-template #footerTemplated2>
                                    <hr class="my-0">
                                    <button class="btn btn-primary btn-sm m-2 float-left today-btn"
                                        [ngClass]="{'disabled' : ngbCalendar.getToday().before(autoGoveranceStartDateValue)}"
                                        [disabled]="ngbCalendar.getToday().before(autoGoveranceStartDateValue)"
                                        (click)="setToday('autoGoveranceEndDate'); d2.close()">Today</button>
                                    <button class="btn btn-secondary btn-sm m-2 float-right"
                                        (click)="resetDate('autoGoveranceEndDate'); d2.close()">Clear</button>
                                </ng-template>
                            </div>
                        </div>
                        <!-- Booked Slots Section -->
                        <div class="col booked-slots" [hidden]="perfLabValue.parallelFlow">
                            <h5>Booked Slots</h5>
                            <p *ngIf="!autoGoveranceEndDateValue">Please select from calender to view booked slots</p>
                            <p *ngIf="blockedSlots.length === 0 && autoGoveranceEndDateValue">No Slots are blocked for
                                the selected date</p>
                            <table class="table table-condensed" *ngIf="blockedSlots.length > 0">
                                <thead>
                                    <tr>
                                        <th>Location</th>
                                        <th>Duration (in mins)</th>
                                        <th>StartTime</th>
                                        <th>EndTime</th>
                                    </tr>
                                </thead>
                                <tr *ngFor="let blockedSlots of blockedSlots">
                                    <td>{{blockedSlots.location}}</td>
                                    <td>{{blockedSlots.duration}}</td>
                                    <td>{{blockedSlots.startTime}}</td>
                                    <td>{{blockedSlots.endTime}}</td>
                                </tr>
                            </table>
                        </div>
                        <!-- Select Time -->
                        <div class="col">
                            Start Time
                            <ngb-timepicker formControlName="startTime" [meridian]="true" size="small"></ngb-timepicker>
                            Current Date & Time (PST) : {{currentPSTTime}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3" *ngIf="perfLabValue.loadTestConfig">
            <div class="perf-box">
                <div class="perf-head">Location</div>
                <div class="perf-body">
                    <div class="row">
                        <div class="col-md-12 col-xs-12">
                            <ng-select class="required custom-style pl-0"
                                [(ngModel)]="perfLabValue.loadTestConfig.location"
                                [ngModelOptions]="{ standalone: true }" placeholder="Select Location"
                                [searchable]="true">
                                <ng-option *ngFor="let location of executionLocations"
                                    [value]="location.location">{{location.location}}</ng-option>
                            </ng-select>
                        </div>
                        <!-- <div class="col-md-6 col-xs-6" *ngFor="let executionLoc of ">
                            <div class="radio" *ngIf="perfLabValue.loadTestConfig !== undefined">
                                <input type="radio" name="location" [value]="executionLoc.name"
                                    [checked]="perfLabValue.loadTestConfig.location === executionLoc.name.toUpperCase()"
                                    (click)="locationSelect(executionLoc)"> {{executionLoc.name}}
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="perf-box"
                *ngIf="perfLabValue.testCase !== null && perfLabValue.testCase !== undefined && perfLabValue.testCase.loadTestType === 'API'">
                <div class="perf-body">
                    <div class="row">
                        <div class="mx-4 mt-3" *ngIf="perfLabValue.loadTestConfig !== undefined">
                            <label class="mr-2">Store Result</label>
                            <ui-switch size="small" [(ngModel)]="perfLabValue.loadTestConfig.storeResult"
                                [ngModelOptions]="{standalone: true}" checkedLabel="Yes" uncheckedLabel="No"
                                [checked]="perfLabValue.loadTestConfig.storeResult"></ui-switch><br>
                            <span style="color:#c0d04d;font-size: 12px"
                                *ngIf="perfLabValue?.parallelFlow && perfLabValue.loadTestConfig.storeResult">Note :
                                Please make sure you have downloaded the result file from the previous run as it will be
                                over written with this run</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Buttons -->
    <div class="row">
        <div class="col-6">
            <div *ngIf="errorMsg" [innerHTML]="errorMsg"></div>
        </div>
        <div class="col-6 text-right">
            <a (click)="goBack()">
                << Back</a> <button [disabled]="disabledScheduleBtn()" type="button" class="btn btn-primary btn-sm ml-3"
                        (click)="submitLoadTesting(perfLabValue)" name="button">Schedule Test</button>
        </div>

    </div>
</form>